import apiClient from "../../utils/api.client";

const getSalesReports = async (raffleId, raffleNumber) => {
  // return fetch(`${getServiceUrl()}/deliverynote/sales-report?raffleId=${raffleId}`, {
  //   headers: {
  //     'Accept': 'text/plain, application/json'
  //   }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.blob();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .then(blob => {
  //     const url = URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.download = `Ventas04 Sorteo ${raffleNumber || "0"}.txt`;
  //     link.style.display = 'none';
  //
  //     // Evita que se genere una url falsa blob-data
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(url);
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    const url = `/delivery-service/deliverynote/sales-report?raffleId=${raffleId}`;
    const response = await apiClient.get(url);
    const data = response.blob().then((element) => {
      const url = URL.createObjectURL(element);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Ventas04 Sorteo ${raffleNumber || "0"}.txt`;
      link.style.display = "none";

      // Evita que se genere una url falsa blob-data
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });

    return data;
  } catch (error) {
    console.log("Error at getSalesReports EP: ", error);
    throw error;
  }
};

// WARNING: Keep an eye on this function
const getSalesReportsTable = async (page, pageSize, sort, raffleId, date) => {
  // const { criteria, field } = sort;
  // return fetch(`${getServiceUrl()}/deliverynote/sales-report/files?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || 'DESC'}&orderField=${field || 'processedFile'}`)
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  const { criteria, field } = sort;
  try {
    const url = `/delivery-service/deliverynote/sales-report/files?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || "DESC"}&orderField=${field || "processedFile"}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getSalesReportsTable EP: ", error);
    throw error;
  }
};

const exportService = {
  getSalesReports,
  getSalesReportsTable,
};

export default exportService;
